import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import ListViewCpt from '@/components/list/ListViewCpt';
import cptCmn from '@/mixin/cpt-cmn';
import { rqtPostAgentMonthInsCommissionDtlList } from '@/services/wms/commission';
export default {
  mixins: [cptCmn],
  components: {
    PageNavBackLayoutCpt,
    ListViewCpt
  },
  data() {
    return {
      searchForm: {
        agentMonthCommissionId: this.$route.query.agentMonthCommissionId
      },
      btnLoading: false,
      listRequest: rqtPostAgentMonthInsCommissionDtlList,
      codeResItems: [{
        title: '订单状态',
        dataIndex: 'orderStatus',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'orderStatus'
      }, {
        title: '主附险',
        dataIndex: 'prFlag',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'prFlag'
      }]
    };
  },
  computed: {},
  mounted() {
    this.initResCodeType(this.codeResItems);
  },
  methods: {}
};